/** Padding in pixels around the route when the map fits to it. */
export const ROUTE_BOUNDS_PADDING = 80;

/** Zoom when the map centres on a route with a single stop. */
export const SINGLE_STOP_ZOOM = 14;
